
export default function Services() {
  const services = [
    {
      icon: 'ri-file-list-3-line',
      title: '補助金・助成金サポート',
      description: '最新制度の情報収集から、補助金診断、申請書作成支援、報告書支援まで一貫対応します。東京都・神奈川県のローカル制度にも深く精通しており、地域に寄り添った提案が可能です。',
      features: [
        '最新補助金情報の定期配信',
        '補助金診断レポート作成',
        '申請書類の作成支援',
        '採択後の報告書サポート',
        '東京・神奈川の地域制度対応'
      ],
      image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20business%20professional%20analyzing%20subsidy%20grant%20documents%20and%20financial%20reports%20on%20large%20digital%20display%20screen%20in%20bright%20contemporary%20office%20with%20clean%20white%20walls%20natural%20daylight%20from%20windows%20showing%20charts%20graphs%20and%20application%20forms%20on%20monitor%20organized%20desk%20with%20laptop%20and%20official%20papers%20professional%20atmosphere%20conveying%20expertise%20and%20trust%20in%20government%20subsidy%20consulting%20ultra%20sharp%20corporate%20style&width=800&height=600&seq=service001&orientation=landscape'
    },
    {
      icon: 'ri-scales-3-line',
      title: '法務サポート(行政書士対応)',
      description: '契約書作成・チェック、内容証明作成、許認可の相談など、企業に必要な法務リスク管理を網羅します。補助金と法務を同時に相談できる体制は、トラブルの予防にも大きく貢献します。',
      features: [
        '契約書の作成・リーガルチェック',
        '内容証明郵便の作成代行',
        '各種許認可申請の相談',
        '法務リスクの事前診断',
        '補助金と連動した法務対応'
      ],
      image: 'https://readdy.ai/api/search-image?query=Close-up%20detailed%20view%20of%20professional%20hands%20carefully%20reviewing%20and%20signing%20legal%20contract%20documents%20on%20elegant%20wooden%20desk%20with%20official%20stamps%20seals%20and%20legal%20papers%20visible%20warm%20professional%20office%20lighting%20showing%20precise%20hand%20movements%20writing%20with%20fountain%20pen%20organized%20workspace%20with%20law%20books%20in%20soft%20focus%20background%20conveying%20precision%20expertise%20and%20legal%20authority%20ultra%20sharp%20professional%20photography%20focusing%20exclusively%20on%20hands%20and%20documents%20no%20face%20visible%20business%20formal%20attire%20sleeves%20visible&width=800&height=600&seq=service002legal&orientation=landscape'
    },
    {
      icon: 'ri-pages-line',
      title: 'LP制作・マーケティングサポート',
      description: '補助金の内容を「売れるLP」に落とし込む、独自のLP制作サービスです。補助金と集客を連動させ、問い合わせ増加や成約率向上を実現します。',
      features: [
        '補助金活用を訴求するLP制作',
        'コンバージョン重視の設計',
        'スマホ完全対応デザイン',
        'SEO対策の実装',
        '問い合わせフォーム最適化'
      ],
      image: 'https://readdy.ai/api/search-image?query=Close-up%20detailed%20view%20of%20creative%20designer%20hands%20typing%20on%20modern%20keyboard%20with%20multiple%20high-resolution%20screens%20displaying%20responsive%20website%20landing%20page%20designs%20colorful%20UI%20UX%20mockups%20and%20design%20software%20interface%20in%20bright%20minimalist%20creative%20studio%20workspace%20clean%20white%20desk%20with%20design%20tools%20color%20swatches%20stylus%20pen%20and%20coffee%20cup%20natural%20daylight%20creating%20inspiring%20atmosphere%20detailed%20hand%20movements%20representing%20digital%20marketing%20and%20web%20development%20expertise%20ultra%20sharp%20professional%20photography%20focusing%20exclusively%20on%20hands%20and%20workspace%20no%20face%20visible%20business%20casual%20attire&width=800&height=600&seq=service003design&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            <span className="text-blue-900">3つの柱</span>で支える<br />トータルサポート
          </h3>
          <p className="text-lg text-gray-600">補助金・法務・集客を一社で完結</p>
        </div>

        <div className="space-y-16">
          {services.map((service, index) => (
            <div 
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center`}
            >
              <div className="flex-1">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-blue-700 rounded-2xl flex items-center justify-center">
                    <i className={`${service.icon} text-white text-3xl`}></i>
                  </div>
                  <h4 className="text-3xl font-bold text-gray-900" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    {service.title}
                  </h4>
                </div>

                <p className="text-lg text-gray-700 leading-relaxed mb-6">
                  {service.description}
                </p>

                <div className="bg-gradient-to-br from-blue-50 to-orange-50 rounded-xl p-6">
                  <h5 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <i className="ri-check-double-line text-blue-900"></i>
                    主なサービス内容
                  </h5>
                  <ul className="space-y-3">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <i className="ri-arrow-right-s-line text-orange-500 mt-1 flex-shrink-0"></i>
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="flex-1">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                  <img 
                    src={service.image}
                    alt={service.title}
                    className="w-full h-96 object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
